import { AfterViewInit, Component, Inject, OnDestroy, OnInit, inject } from '@angular/core';
import moment from 'moment';

import { InvestimentsBase } from '../investiments.base';
import { CompaniesService } from './companies.service';
import { CompanyCreateComponent } from './create/create.component';
import { CompanyModifyComponent } from './modify/modify.component';

import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-companies',
  standalone: false,
  templateUrl: './companies.component.html',
  styleUrl: './companies.component.css'
})
export class CompaniesComponent extends InvestimentsBase<CompanyCreateComponent, CompanyModifyComponent> implements AfterViewInit {

  override service = inject(CompaniesService)

  override list : any = {
    columns: [
      'name', 'code', 'active', 'action',
    ],
    data: []  
  }
  
  constructor() {
    super(CompanyCreateComponent, CompanyModifyComponent)
  }

  async ngAfterViewInit(): Promise<void> {
    console.error('CompaniesComponent -> ngAfterViewInit')

    console.log("listCompanies: ", this.list.data)
  }

  override async evaluate(r: any):Promise<boolean> {
    console.error('CompaniesComponent -> evaluate', r)

    const exists = this.list.data.filter((e:any) => {
      return (e.name == r.name || e.code == r.code) && e.id != r.id
    })[0]
    
    return exists==undefined
  }
  
}
